<template>
  <div class="row justify-center">
    <loading-spinner v-if="checking" />
    <template v-else>
      <div
        class="card text-center px-1 py-2 m-auto"
        style="width:25rem;"
      >
        <img
          class="card-img-top py-3 px-5"
          src="../assets/images/logo-aequaroma.jpg"
          alt="AEqua Roma"
        >
        <template v-if="!base">
          <div class="text-center my-2">Servizi per gli utenti del Patrimonio Immobiliare di Roma Capitale</div>
          <div class="d-flex flex-column card-body">
            <template v-if="$store.getters.hasLocal">
              <h5 class="card-title text-uppercase">Accesso base</h5>
              <!--<p class="card-text">breve descrizione accesso base..</p> -->
              <p class="card-text"></p>
              <a
                href="https://www.aequaroma.it/assets/pdf/patrimonio/condizioni_utilizzo_servizi_patrimonio.pdf"
                target="_blank"
              >
                Condizioni di utilizzo
              </a>.

              <br>

              <div style="h-align: center">
                <b-button
                  variant="primary"
                  size="lg"
                  @click="onAccessoBaseClick"
                >Accesso base</b-button>
              </div>
            </template>
            <template v-if="$store.getters.hasSpid">
              <h5 class="card-title text-uppercase mt-4">Accesso completo</h5>
              <!-- <p class="card-text">..breve descrizione accesso completo..</p> -->
              <p class="card-text"></p>

              <div style="h-align: center">
                <a
                  href="/api/auth/loginSpid"
                  class="italia-it-button italia-it-button-size-m button-spid"
                  spid-idp-button="#spid-idp-button-small-get"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span class="italia-it-button-icon">
                    <img
                      src="../../public/spid/img/spid-ico-circle-bb.svg"
                      onerror="this.src='../../public/spid/img/spid-ico-circle-bb.png'; this.onerror=null"
                      alt=""
                    />
                  </span>
                  <span class="italia-it-button-text">Entra con SPID</span>
                </a>
              </div>

              <div style="h-align: center">
                <a
                  href="/api/auth/loginCie"
                  class="italia-it-button italia-it-button-size-m button-spid"
                  spid-idp-button="#spid-idp-button-small-get"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span class="italia-it-button-icon">
                    <img
                      src="../../public/cie/img/Logo_CIE_ID.svg"
                      onerror="this.src='../../public/spid/img/spid-ico-circle-bb.png'; this.onerror=null"
                      alt=""
                    />
                  </span>
                  <span class="italia-it-button-text">Entra con CIE</span>
                </a>
              </div>

              <!-- <SpidSmartButton />
              <div
                style="background-color: #06c; text-align: left; padding: 0"
                xxxhref="/api/auth/loginSpid"
              >
                <img
                  aria-hidden="true"
                  src="../../public/spid/img/spid-ico-circle-bb.svg"
                  style="width: 30px; margin: 10px"
                  onerror="this.src=\'/spid/img/spid-ico-circle-bb.png\'; this.onerror=null;"
                  alt="Entra con SPID"
                />
                <span style="height: 60px; margin-left: 14px; padding-left: 14px; border-left: 1px solid #ffffffdd">
                  Entra con SPID
                </span>
              </div>
              -->

              <!-- <a
                href="#"
                class="italia-it-button italia-it-button-size-l button-spid"
                spid-idp-button="#spid-idp-button-large-get"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span class="agid-spid-enter-icon"><img
                    aria-hidden="true"
                    src="../../public/spid/img/spid-ico-circle-bb.svg"
                    onerror="this.src=\'/spid/img/spid-ico-circle-bb.png\'; this.onerror=null;"
                    alt="Entra con SPID"
                  /></span>
                <span class="agid-spid-enter-text">Entra con SPID</span>
              </a> -->
            </template>
          </div>
        </template>
        <template v-else>
          <div class="d-flex flex-column card-body align-middle">
            <b-input
              v-model="username"
              type="text"
              placeholder="Codice fiscale"
              class="m-1"
              :formatter="formatUcase"
              :state="fieldCodiceFiscale"
              autofocus
            />
            <b-input-group>
              <b-input
                v-model="password"
                :type="passwordFieldType"
                :formatter="formatTrim"
                placeholder="Password"
                class="m-1"
              />
              <b-input-group-append>
                <font-awesome-icon
                  :icon="fieldIcon"
                  size="lg"
                  class="text-primary cursor-pointer align-self-center"
                  @click="showPassword()"
                />
              </b-input-group-append>
            </b-input-group>
            <b-button
              variant="link"
              @click="onRegistratiClick"
            >Registrati</b-button>
            <b-button
              variant="link"
              @click="onRichiediPasswordClick"
            >Ho dimenticato la password</b-button>
            <b-button
              variant="primary"
              size="lg"
              class="m-1"
              @click="onLoginClick"
            >Entra</b-button>
            <b-button
              variant="outline-secondary"
              size="lg"
              class="m-1"
              @click="onCancelClick"
            >Annulla l'accesso</b-button>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import LoadingSpinner from '@/components/LoadingSpinner'
// import SpidSmartButton from '@/components/SpidSmartButton'
import { required } from 'vuelidate/lib/validators'

const codiceFiscaleLengh = (value, vm) => {
  let retValue = false

  if (value.length === 16 || value.length === 11) {
    retValue = true
  }

  return retValue
}

const codiceFiscale = (value, vm) => {
  var reCF = /[A-Za-z]{6}[0-9lmnpqrstuvLMNPQRSTUV]{2}[abcdehlmprstABCDEHLMPRST]{1}[0-9lmnpqrstuvLMNPQRSTUV]{2}[A-Za-z]{1}[0-9lmnpqrstuvLMNPQRSTUV]{3}[A-Za-z]{1}/
  var rePIVA = /[0-9]{11}/
  let retValue = false

  if (value.length === 16) {
    if (reCF.test(value)) {
      retValue = true
    }
  } else {
    if (rePIVA.test(value)) {
      retValue = true
    }
  }

  return retValue
}

export default {

  components: {
    LoadingSpinner
    // SpidSmartButton
  },

  data: () => {
    return {
      checking: true,
      base: false,
      username: '',
      password: '',
      passwordFieldType: 'password',
      fieldIcon: 'eye-slash'
    }
  },

  async beforeRouteEnter (to, from, next) {
    next(async (vm) => {
      // console.log('$store', vm.$store.getters.hasLocal, vm.$store.getters.hasSpid, vm.$store.getters.isAuthenticated)
      try {
        await vm.$store.dispatch('info')
        if (vm.$store.getters.isAuthenticated) vm.$router.push({ name: 'home' })
      } catch (err) {
        this.$ui.showError(err)
      }
      vm.checking = false
    })
  },

  computed: {
    fieldCodiceFiscale () {
      this.$v.username.$touch()

      return !this.$v.username.$invalid
    }
  },
  validations: {
    username: { required, codiceFiscaleLengh, codiceFiscale }
  },

  methods: {
    onAccessoBaseClick () {
      this.base = true
    },
    async onAccessoSpidClick () {
      // Passare il controllo allo SPID gateway
      await this.$store.dispatch('loginSpid')
    },
    onRegistratiClick () {
      this.$router.push({ name: 'registraUtente' })
      this.base = true
    },
    onRichiediPasswordClick () {
      this.$router.push({ name: 'recuperaPassword' })
      this.base = true
    },
    onCancelClick () {
      this.base = false
    },
    async onLoginClick () {
      try {
        if (this.validate()) {
          this.username = this.username.trim()
          this.password = this.password.trim()
          await this.$store.dispatch('login', { username: this.username, password: this.password })
          // console.log('Dati utente: ', this.username, this.$store.state.auth.user)
          if (this.$store.state.auth.user.codiceUtente === 'intermediario') {
            this.$router.push({ name: 'landing' })
          } else {
            this.$router.push({ name: 'home' })
          }
        } else {
          this.$ui.notify({
            type: 'warning',
            title: 'Dati non corretti',
            message: 'Verificare le credenziali di accesso.'
          })
        }
      } catch (err) {
        this.$ui.showError(err)
        // console.log('Accesso non consentito. Verificare le credenziali di accesso.', err)
        this.$ui.notify({
          type: 'warning',
          title: 'Attenzione',
          message: 'Accesso non consentito. Verificare le credenziali di accesso.'
        })
      }
    },
    formatUcase (value, event) {
      if (value.length > 16) {
        value = value.substr(0, 16)
      }
      return value.toUpperCase().trim()
    },
    formatTrim (value, event) {
      return value.trim()
    },
    validate () {
      this.$v.username.$touch()

      return !this.$v.username.$invalid
    },
    showPassword () {
      if (this.passwordFieldType === 'password') {
        this.passwordFieldType = 'text'
        this.fieldIcon = 'eye'
      } else {
        this.passwordFieldType = 'password'
        this.fieldIcon = 'eye-slash'
      }
    }

  }

}
</script>

<style lang="stylus" scoped>
.italia-it-button {
  display: inline-block;
  position: relative;
  padding: 0;
  color: #FFF;
  font-family: 'Titillium Web', HelveticaNeue, Helvetica Neue, Helvetica, Arial, Lucida Grande, sans-serif;
  font-weight: 600;
  line-height: 1em;
  text-decoration: none;
  border: 0;
  text-align: center;
  cursor: pointer;
  overflow: hidden;
}

.italia-it-button-icon, .italia-it-button-text {
  display: block;
  float: left;
}

.italia-it-button-icon {
  margin: 0 -0.4em 0 0;
  padding: 0.6em 0.8em 0.5em;
  border-right: rgba(255, 255, 255, 0.1) 0.1em solid;
}

.italia-it-button-text {
  padding: 0.95em 1em 0.85em 1em;
  font-size: 1.15em;
  text-align: center;
}

svg {
  width: 1.8em;
  height: 1.8em;
  fill: #fff;
}

.italia-it-block {
  display: block;
}

.italia-it-button-size-s {
  font-size: 10px;
  width: 150px;
}

.italia-it-button-size-s > span img {
  width: 19px;
  height: 19px;
  border: 0;
}

.italia-it-button-size-m {
  font-size: 15px;
  width: 220px;
}

.italia-it-button-size-m > span img {
  width: 29px;
  height: 29px;
  border: 0;
}

.italia-it-button-size-l {
  font-size: 20px;
  width: 280px;
}

.italia-it-button-size-l > span img {
  width: 38px;
  height: 38px;
  border: 0;
}

.italia-it-button-size-xl {
  font-size: 25px;
  width: 340px;
}

.italia-it-button-size-xl > span img {
  width: 47px;
  height: 47px;
  border: 0;
}

.button-spid {
  background-color: #06C;
  color: #FFF;
}

.button-spid svg {
  fill: #FFF;
}

.button-spid:hover {
  background-color: #036;
  color: #FFF;
}

.button-spid:active {
  background-color: #83BEED;
  color: #036;
}

.spid-idp-button {
  position: absolute;
  z-index: 1039;
  display: none;
}

.spid-idp-button .spid-idp-button-menu, .spid-idp-button .spid-idp-button-panel {
  list-style: none;
  background: white;
  border: solid 1px #ddd;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  overflow: visible;
  padding: 0;
  margin: 0;
}

#spid-idp-button-small-get, #spid-idp-button-medium-get, #spid-idp-button-small-post, #spid-idp-button-medium-post {
  width: 230px;
}

#spid-idp-button-large-get, #spid-idp-button-large-post {
  width: 270px;
}

#spid-idp-button-xlarge-get, #spid-idp-button-xlarge-post {
  width: 330px;
}

.spid-idp-button .spid-idp-button-panel {
  padding: 10px;
}

.spid-idp-button.spid-idp-button-tip {
  margin-top: 8px;
}

.spid-idp-button.spid-idp-button-tip:before {
  position: absolute;
  top: -6px;
  left: 9px;
  content: '';
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #ddd;
  display: inline-block;
}

.spid-idp-button.spid-idp-button-tip:after {
  position: absolute;
  top: -5px;
  left: 10px;
  content: '';
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid white;
  display: inline-block;
}

.spid-idp-button.spid-idp-button-tip.spid-idp-button-anchor-right:before {
  left: auto;
  right: 9px;
}

.spid-idp-button.spid-idp-button-tip.spid-idp-button-anchor-right:after {
  left: auto;
  right: 10px;
}

.spid-idp-button.spid-idp-button-scroll .spid-idp-button-menu, .spid-idp-button.spid-idp-button-scroll .spid-idp-button-panel {
  max-height: 180px;
  overflow: auto;
}

.spid-idp-button .spid-idp-button-menu li {
  list-style: none;
  padding: 0 0;
  margin: 0;
  line-height: 18px;
}

.spid-idp-button .spid-idp-button-menu li > a, .spid-idp-button .spid-idp-button-menu label {
  display: block;
  font-family: 'Titillium Web', HelveticaNeue, Helvetica Neue, Helvetica, Arial, Lucida Grande, sans-serif;
  font-weight: 600;
  font-size: 0.9em;
  color: #06C;
  text-decoration: underline;
  line-height: 18px;
  padding-top: 5px;
  white-space: nowrap;
  border-bottom: 1px solid #ddd;
}

.spid-idp-button .spid-idp-button-menu li > a:hover, .spid-idp-button .spid-idp-button-menu label:hover {
  color: #036;
  cursor: pointer;
  background-color: #F0F0F0;
}

.spid-idp-button .spid-idp-button-menu li > a img {
  height: 25px;
  padding: 10px 0 10px 10px;
  border: 0;
}

.idp-button-idp-logo {
  font-size: 100%;
  height: 10%;
  width: 100%;
  border: 0;
  border-bottom: 1px solid #CCC;
  background-color: #FFF;
  padding: 15px;
  text-align: left;
  cursor: pointer;
}

.idp-button-idp-logo:hover {
  background-color: #F0F0F0;
}

.idp-button-idp-logo img {
  height: 25px;
  vertical-align: middle;
  cursor: pointer;
}

.spid-top-menu-space-10 > a img {
  margin-top: 10px;
}

.spid-top-menu-space-20 > a img {
  margin-top: 20px;
}

.spid-top-menu-line {
  border-top: 5px solid #000;
}

.spid-idp-support-link > a {
  padding: 5px 0 10px 10px;
}

.spid-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
</style>
